export enum TransactionActionStatus {
  Prohibited = 0,
  Allowed = 1,
  Disabled = 2
}
